import { initializeApp } from 'firebase/app';
import { getFirestore, setDoc, doc } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCm4mGsRoAd8jW4WG-YdIgbhjFjm1C4VI0",
  authDomain: "valentines-miss-you.firebaseapp.com",
  projectId: "valentines-miss-you",
  storageBucket: "valentines-miss-you.firebasestorage.app",
  messagingSenderId: "492160655745",
  appId: "1:492160655745:web:6aa651e3ae9c4719008880",
  measurementId: "G-55GJXNV4G9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Handle foreground messages
const messaging = getMessaging(app);
onMessage(messaging, (payload) => {
  console.log('Foreground message received:', payload);
  // Handle foreground notifications here if needed
});

// Firebase Auth helper functions
export const loginWithEmail = async (email: string, password: string) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const logoutUser = async () => {
  try {
    await signOut(auth);
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const onAuthChange = (callback: (user: any) => void) => {
  return onAuthStateChanged(auth, callback);
};

export async function syncFcmToken(userId: 'tim' | 'diya' | null) {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return;
    }

    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
        vapidKey: 'BLYNIVc4s-K7VP4epdym8xwZlk3d8FDppgspYBlIUX35GmjbtWVWouO1kg6cKrclZZecr3I5aVFa8F3P2kEk0EE',
        serviceWorkerRegistration: registration
      });

    if (!token) {
      console.log("No FCM token returned");
      return;
    } else {
      console.log(`Got FCM token ${token}`)
    }

    await setDoc(doc(db, 'users', userId ?? 'tim'), { fcmToken: token }, { merge: true });

  } catch (err) {
    console.error("Error getting token:", err);
  }
}
